<div class="emptyScreen d-flex">
  <div class="rounded-lg d-flex justify-content-center align-items-center flex-grow-1" style="flex-direction: column;">
    <div> 
      <b style="font-size: 16px; color: #484b59">
        Create your first campaign
      </b>
    </div>
    <div >
      <img src="../../../assets/images/email-campaign_banner.png" alt="Image 1">
    </div>
    <div>
      <button data-testid="auto-app-email-campaign-dashboard-button-1" class="btn-trms-medium" (click)="createCampaign()"><i class="far fa-add mr-2"></i>Create new campaign</button>
    </div>
  </div>
</div>


<ngb-alert class="ngb-alert" *ngIf="successMessage" type="success" (close)="successMessage = ''">
  <span class="successCheck"><i class="fal fa-check"></i> </span>
  <span class="successmsg">{{ successMessage }}</span>
</ngb-alert>

<ngb-alert class="ngb-alert" *ngIf="errorMessage" type="danger" (close)="errorMessage = ''">
  <span class="errorCheck"><i class="fal fa-times"></i></span>
  <span class="errormsg"> {{ errorMessage }} </span>
</ngb-alert>
